<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-card>
      <div slot="header">Bukti Potong (Form 1721 A1)
        <div class="card-header-actions">
         <button class="btn btn-primary mr-1" @click="process_Confirm=true"><i class="fa fa-play"></i> Process</button>
         <!-- <b-button variant="primary mr-1" @click="edit">Edit</b-button> -->
         <button class="btn btn-primary mr-1" @click="print()">
              <i class="fa fa-print"></i>
              Print Form
          </button>
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row class="ml-2 mr-2">
        <b-col lg="7">
            <b-row>
              <b-col lg="6">
                  <b-input-group>
                    <b-input-group-prepend><label>Tahun Pajak</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tahunpajak" type='number' ></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="6">
              </b-col>
            </b-row>            
            <b-row>
              <b-col  lg="6">
                  <b-input-group>
                      <b-input-group-prepend><label>Department</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.departemen" placeholder="Departmenet Name"></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Job Title</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.jabatan" placeholder="Job Title"></b-form-input>
                    </b-input-group>
              </b-col>
            </b-row>            
        </b-col>
        <b-col lg="5">
            <b-input-group >
              <b-input-group-prepend><label>Employee </label></b-input-group-prepend>
                <b-form-input v-model="tblData.crewname" placeholder="Name" class="mr-1" style="width:40% !important;"></b-form-input>
                <b-form-input v-model="tblData.crewnik" placeholder="ID Number"></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Project</label></b-input-group-prepend>
                <b-form-input readonly v-model="tblData.projectname" ></b-form-input>
                <b-input-group-append>
                    <b-btn text="Button" @click="lkuCustomerShow=true" ><i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
                    <b-button class="btn btn-success ml-1 mr-1" @click="getData" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear</b-button>
            </b-input-group>


        </b-col>        
      </b-row>                      
      <b-card no-body>
            <b-row v-if="(filterShow=='Hide')" class="mt-2">
                <b-col lg="4">
                    <b-form-group
                        label="Filter"
                        label-cols-sm="1"
                        label-size="sm"
                        label-for="filterInput"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>  
                </b-col> 
                <b-col lg="5">
                  <b-form-group
                    label="Filter On"
                    label-cols-sm="1"
                    label-size="sm"
                    description="Leave all unchecked to filter on all data"
                    class="mb-0">
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                      <b-form-checkbox value="projectname">Project</b-form-checkbox>
                      <b-form-checkbox value="locationname">Location</b-form-checkbox>
                      <b-form-checkbox value="crewname">Employee Name</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>                
                </b-col>                 
                <b-col lg="3">
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>
                </b-col>         
            </b-row>
            <b-table
                class="mb-0 text-nowrap"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="rptLines"
                :fields="tblData.fields"
                :current-page="tblData.page"
                :per-page="tblData.limit"
                :sort-by.sync="tblData.sortBy"
                :sort-desc.sync="tblData.sortDesc"
                :filter="filter"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"    
                @row-clicked="rowClicked"            
            >
                <template v-slot:cell(index)="data">
                      {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
                </template>
                <template v-slot:cell(tglpotong)="data">
                      {{ data.item.tglpotong |  moment("D-MMM-YY") }}
                </template>
                <template v-slot:cell(line01)="data">
                  {{data.item.line01|numFormat}}
                </template>
                <template v-slot:cell(line02)="data">
                  {{data.item.line02|numFormat}}
                </template>
                <template v-slot:cell(line03)="data">
                  {{data.item.line03|numFormat}}
                </template>
                <template v-slot:cell(line04)="data">
                  {{data.item.line04|numFormat}}
                </template>
                <template v-slot:cell(line05)="data">
                  {{data.item.line05|numFormat}}
                </template>
                <template v-slot:cell(line06)="data">
                  {{data.item.line06|numFormat}}
                </template>
                <template v-slot:cell(line07)="data">
                  {{data.item.line07|numFormat}}
                </template>
                <template v-slot:cell(line08)="data">
                  {{data.item.line08|numFormat}}
                </template>
                <template v-slot:cell(line09)="data">
                  {{data.item.line09|numFormat}}
                </template>
                <template v-slot:cell(line10)="data">
                  {{data.item.line10|numFormat}}
                </template>
                <template v-slot:cell(line11)="data">
                  {{data.item.line11|numFormat}}
                </template>
                <template v-slot:cell(line12)="data">
                  {{data.item.line12|numFormat}}
                </template>
                <template v-slot:cell(line13)="data">
                  {{data.item.line13|numFormat}}
                </template>
                <template v-slot:cell(line14)="data">
                  {{data.item.line14|numFormat}}
                </template>
                <template v-slot:cell(line15)="data">
                  {{data.item.line15|numFormat}}
                </template>
                <template v-slot:cell(line16)="data">
                  {{data.item.line16|numFormat}}
                </template>
                <template v-slot:cell(line17)="data">
                  {{data.item.line17|numFormat}}
                </template>
                <template v-slot:cell(line18)="data">
                  {{data.item.line18|numFormat}}
                </template>
                <template v-slot:cell(line19)="data">
                  {{data.item.line19|numFormat}}
                </template>
                <template v-slot:cell(line20)="data">
                  {{data.item.line20|numFormat}}
                </template>
            </b-table>
            <b-row class="mt-2">
                <b-col cols="4">
                    <div style="font-weight: bold;" class="ml-1">Total : {{uanguser}}
                        <div style="text-align:right; border:1px solid silver; width:200px;height:40px;border-top: 1px solid #000 ;border-bottom: 2px solid #000; background: #e6e6e6; display:inline;" class="pl-2 pt-2 pr-2">
                          {{subtotal.totalTHP | numFormat('0,0.00')}}</div>
                    </div>
                </b-col>
                <b-col cols="8">
                    <b-row >
                      <b-col cols="6" style="text-align:center">
                        <div>
                          Showing {{(tblData.page - 1) * tblData.limit + 1}}
                          to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                          of {{tblData.total}} entries,   <span class="ml-3 mr-1">limit per page :</span> 
                          <select  v-model="tblData.limit"  style="width:60px;">
                            <option>10</option>
                            <option>15</option>
                            <option>20</option>                            
                            <option>25</option>
                            <option>30</option>                            
                          </select>
                        </div>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch switch>
                          <b> {{ filterShow }}</b>  Filter by Project/Location, etc..
                        </b-form-checkbox>
                      </b-col>
                      <b-col cols="6">            
                        <b-pagination 
                          align="right"
                          :total-rows="tblData.total"
                          :per-page="tblData.limit"
                          v-model="tblData.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                </b-col>
            </b-row>
      </b-card>
  </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="process_Confirm" title="Prosess Bukti Potong PPh21 (Form 1721)" :centered="true" header-bg-variant="primary" hide-footer>
              <b-row>
                <b-col lg="8">
                  <b-input-group>
                    <b-input-group-prepend><label>Tahun Pajak</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.tahunpajak" type='number'></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>

            <div style="text-align:right; display:blocked" class="mt-3" >
                <b-button variant="success" @click="frm1721process"><i class="fa fa-play"></i> Process/Generate </b-button>
                <b-button variant="danger" class="ml-1" @click="frm1721cancel" > <i class="fa fa-undo"></i> Cancel/Remove </b-button>
                <b-button variant="secondary" class="ml-1" @click="process_Confirm=false" > <i class="fa fa-close"></i> Close</b-button>
            </div>
    </b-modal>

  </div>
</template>

<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }
    iframe {
        border: 1px solid #ccc;
        width: 100%;
        height: 11in;
    }
</style>

<script>
import moment from 'moment';
import frm1721 from "../../apis/payrollfrm1721";
import Loading from 'vue-loading-overlay';
import accounting from 'accounting-js'
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
      tahunpajak: { required }
    },
  }, 
  data() {
    return {
      process_Confirm: false,
      isLoading:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      model: {},
      frmdata: {tahunpajak:moment().format('YYYY')},
      filterShow:'Show',
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      rptLines : [],
      subtotal : {},
      limit:15,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
      fields: [
          { key: "crewnik" , 
            label: "Employee ID",
            thStyle: "width:100px",
            sortable: true
          },
          { key: "crewname" , 
            label: "Employee Name",
            thStyle: "width:250px",
            sortable: true
          },
          {
            key: "jabatan",
            label: "Job Title",
            thStyle: "width:150px",
          },
          {
            key: "departemen",
            label: "Department",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "projectname",
            label: "Client/Project",
            sortable: true
          },
         {
            key: "crewmale",
            thStyle: "width:40px",
            label: "Laki2"
          },
         {
            key: "kawin",
            thStyle: "width:40px",
            label: "Kawin"
          },
         {
            key: "wni",
            thStyle: "width:30px",
            label: "WNA"
          },
          {
            key: "line01",
            thStyle: "width:100px",
            label: "Gaji",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line02",
            thStyle: "width:100px",
            label: "Tunjangan PPh",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line03",
            thStyle: "width:100px",
            label: "Tunjangan Lainnya",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line04",
            thStyle: "width:100px",
            label: "Honorarium",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line05",
            thStyle: "width:100px",
            label: "Premi Asuransi",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line06",
            thStyle: "width:100px",
            label: "Natura",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line07",
            thStyle: "width:100px",
            label: "Bonus",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line08",
            thStyle: "width:100px",
            label: "JML.BRUTO PENGHASILAN",
            thClass: "text-right",
            tdClass: "text-right",
            variant: "success",
          },
          {
            key: "line09",
            thStyle: "width:100px",
            label: "Biaya Jabatan",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line10",
            thStyle: "width:100px",
            label: "Iuran Pensiun",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line11",
            thStyle: "width:100px",
            label: "JUMLAH PENGURANGAN",
            thClass: "text-right",
            tdClass: "text-right",
            variant: "danger",
          },
          {
            key: "line12",
            thStyle: "width:100px",
            label: "PENGHASILAN NETTO",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line13",
            thStyle: "width:100px",
            label: "Netto Sebelumnya",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line14",
            thStyle: "width:100px",
            label: "NETTO DISETAHUNKAN",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line15",
            thStyle: "width:100px",
            label: "PTKP",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line16",
            thStyle: "width:100px",
            label: "PKP",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line17",
            thStyle: "width:100px",
            label: "PPh21 PKP",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line18",
            thStyle: "width:100px",
            label: "PPh21 Dipotong Sebelumya",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line19",
            thStyle: "width:100px",
            label: "PPh21 Terutang",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "line20",
            thStyle: "width:100px",
            label: "PPh21 Dipotong",
            thClass: "text-right",
            tdClass: "text-right",
          },
          { key: "nomor" , 
            label: "Nomor Bukti Potong",
            thStyle: "width:100px",
            sortable: true
          },
          { key: "tglpotong" , 
            label: "Tgl. Bukti Potong",
            thStyle: "width:100px",
            sortable: true
          },
          
      ]
      },
      filter: null,
      filterOn: [],   
    };
  },
  components: {Loading},
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },  
  created: async function(){
      // const kolfrm1721 = await frm1721.komponenfrm1721();
      // kolfrm1721.forEach(kol => {
      //   const ada = this.tblData.fields( f=> f.key==`line${kol.IdFrm1721}`);
      //   if (ada) {
      //     ada.label= kol.NmFrm1721;
      //     ada.variant= (dkol.JenisKomp === 'Potongan') ? 'danger':'success';         
      //   }
      // });

        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(3, 'day');
        this.model.tahunpajak=tgl2.format('YYYY');
  },  
  methods: {
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
        this.subtotal.totalTHP = filteredItems.reduce((a, b) => a + b.takehomepay, 0);
    },      
    numberFormat(val) {
      return `${accounting.formatNumber(val)}`
    },
    frm1721process: async function()
    {
      if (this.invalidFrmdata) {
            console.log('validation : ', this.$v.frmdata);
            console.log('frmdata obj : ',this.frmdata);
            toastr.error('Please fill the form correctly.', "Error Info");
        } else {
            this.process_Confirm = false;
            this.isLoading=true;
            this.tblData.tahunpajak=this.frmdata.tahunpajak;
            try {
                const response = await frm1721.process(this.frmdata);
                this.isLoading=false;   
                this.getData() ;
            } catch (error) {
                this.isLoading=false;
                this.process_Confirm = true;
                if (error.sql) {
                    toastr.error(error.sql,'Error Info',10000);
                } else {
                  if (error.message) {
                      toastr.error(error.message,'Error Info',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'Error Info',10000);
                  }
                }
            }
        } 
    },
    frm1721cancel: async function()
    {
      if (this.invalidFrmdata) {
            console.log('validation : ', this.$v.frmdata);
            console.log('frmdata obj : ',this.frmdata);
            toastr.error('Please fill the form correctly.', "Error Info");
        } else {
            this.process_Confirm = false;
            this.isLoading=true;
            this.tblData.tahunpajak=this.frmdata.tahunpajak;
            try {
                const response = await frm1721.cancel(this.frmdata);
                this.isLoading=false;   
                this.getData() ;
            } catch (error) {
                this.isLoading=false;
                this.process_Confirm = true;
                if (error.sql) {
                    toastr.error(error.sql,'Error Info',10000);
                } else {
                  if (error.message) {
                      toastr.error(error.message,'Error Info',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'Error Info',10000);
                  }
                }
            }
        } 
    },
    edit: function() {
        if (this.model.frm1721key) {
          const filter = this.$store.state.filter;
          filter.pyrllist=this.tblData;
          this.$store.commit("filter", filter);
          router.push({name: 'hrm.pph21tahunanform', params: { frm1721key: this.model.frm1721key}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    print: async function()
    {
      if (this.model) {
          try {
              this.showReport=true;
              this.reportUrl= await frm1721.print(this.model);
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    
    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.isLoading=true;
        this.model.tahunpajak=moment(this.model.tahunpajak).format('YYYY-MM-DD'); 
        this.rptLines =  await frm1721.list(this.model);
        // this.tblData.total = this.rptLines.length;        
        // this.subtotal.totalTHP = this.rptLines.reduce((a, b) => a + b.takehomepay, 0);
        this.isLoading=false;      
       }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
          
          const data ={};
            data.tahunpajak= moment(this.model.tahunpajak).format('YYYY-MM-DD'); 
            if ((this.filter) && (this.filterOn.length>0)) {
              this.filterOn.forEach( (itemFilt) => {
                data[itemFilt]=this.filter;
              });
            } 
            const response = await frm1721.export(data);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
      }
    },    
    close(){
      router.push("home");
    }
  }
};
</script>
